/**
 * 2024 Tax Year Rules
 * Combines federal and state rules
 */

import { TaxRules } from '../../types';
import { cashMedicalSupportLevelsIA2024 } from './IA/cashMedicalSupportLevels';
import { childSupportLevelsIA2024 } from './IA/childSupportLevels';

export const taxRules2024: TaxRules = {
    year: 2024,
    federal: {
        filing: {
            single: {
                standardDeduction: 14600,
                over65Deduction: 1950,
                blindDeduction: 1950,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 11600.99, rate: 0.10 },
                    { minimumIncome: 11601, maximumIncome: 47150.99, rate: 0.12 },
                    { minimumIncome: 47151, maximumIncome: 100525.99, rate: 0.22 },
                    { minimumIncome: 100526, maximumIncome: 191950.99, rate: 0.24 },
                    { minimumIncome: 191951, maximumIncome: 243725.99, rate: 0.32 },
                    { minimumIncome: 243726, maximumIncome: 609350.99, rate: 0.35 },
                    { minimumIncome: 609351, rate: 0.37 },
                ],
            },
            marriedFilingSeparately: {
                standardDeduction: 14600,
                over65Deduction: 1950,
                blindDeduction: 1950,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 11600.99, rate: 0.10 },
                    { minimumIncome: 11601, maximumIncome: 47150.99, rate: 0.12 },
                    { minimumIncome: 47151, maximumIncome: 100525.99, rate: 0.22 },
                    { minimumIncome: 100526, maximumIncome: 191950.99, rate: 0.24 },
                    { minimumIncome: 191951, maximumIncome: 243725.99, rate: 0.32 },
                    { minimumIncome: 243726, maximumIncome: 365600.99, rate: 0.35 },
                    { minimumIncome: 365601, rate: 0.37 },
                ],
            },
            headOfHousehold: {
                standardDeduction: 21900,
                over65Deduction: 1950,
                blindDeduction: 1950,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 16550.99, rate: 0.10 },
                    { minimumIncome: 16551, maximumIncome: 63100.99, rate: 0.12 },
                    { minimumIncome: 63101, maximumIncome: 100500.99, rate: 0.22 },
                    { minimumIncome: 100501, maximumIncome: 191950.99, rate: 0.24 },
                    { minimumIncome: 191951, maximumIncome: 243700.99, rate: 0.32 },
                    { minimumIncome: 243701, maximumIncome: 609350.99, rate: 0.35 },
                    { minimumIncome: 609351, rate: 0.37 },
                ],
            }
        },
        fica: {
            regularSocialSecurityRate: 6.2,
            seSocialSecurityRate: 12.4,
            regularMedicareRate: 1.45,
            seMedicareRate: 2.9,
            additionalMedicareTaxRate: 0.90,
            socialSecurityThreshold: 168600,
            additionalMedicareTaxThreshold: 200000,
        },
        credits: {
            federalCreditPerDependentUnder17: 2000,
            federalRefundableAmountPerChildUnder17: 1700,
            federalCreditPerDependent17Over: 500,
            childTaxCreditPhaseOutThreshold: 200000,
            phaseOutAmountPerChild: 50,
            dollarAbovePhaseoutThresholdIncrement: 1000,
        },
        qbi: {
            thresholdStart: 191950,
            thresholdEnd: 999_999_999_999,
            tentativeRate: 999_999_999,
            thresholdRate: 2.5,
        },
        earnedIncome: {
            threshold: 2500,
            agiMultiplier: 15, // as percentage
        },
        dependentCare: {
            limitOneDependent: 3000,
            limitTwoOrMoreDependents: 6000,
        },
    },
    states: {
        IA: {
            // Iowa state tax - progressive brackets for 2024
            standardDeductionSingle: 0,
            standardDeductionMarriedFilingSeparately: 0,
            standardDeductionHeadOfHousehold: 0,
            over65Deduction: 0,
            blindDeduction: 0,
            brackets: [
                { minimumIncome: 0, maximumIncome: 6210.99, rate: 0.044 },
                { minimumIncome: 6211, maximumIncome: 31050.99, rate: 0.0482 },
                { minimumIncome: 31051, rate: 0.057 },
            ],
            personalCredit: {
                single: 40,
                marriedFilingSeparately: 40,
                headOfHousehold: 80,
                perDependent: 40,
            },
            qadd: [
                { count: 0, rate: 0.00, minimum: 0 },
                { count: 1, rate: 0.08, minimum: 9_600 },
                { count: 2, rate: 0.12, minimum: 14_400 },
                { count: 3, rate: 0.14, minimum: 16_800 },
                { count: 4, rate: 0.15, minimum: 18_000 },
                { count: 5, rate: 0.16, minimum: 19_200 },
            ],
            support: {
                childSupport: childSupportLevelsIA2024,
                cashMedicalSupport: cashMedicalSupportLevelsIA2024,
            },
        },
    },

};
